module.exports = __webpack_public_path__ + "h5/img/bs_09.3e0a4b3b.jpg";